import { onMounted, onBeforeUnmount } from "vue";
import { getSocket } from "@/utils/socket";

export function useContactChatSocketListeners(callbacks: {
  onChatMessage?: (data: any) => void;
  onReaction?: (data: any) => void;
}) {
  let socket: any = null;

  onMounted(() => {
    socket = getSocket();

    if (callbacks.onChatMessage) {
      socket.on("contact-chat:message", callbacks.onChatMessage);
    }
    if (callbacks.onReaction) {
      socket.on("contact-chat:reaction", callbacks.onReaction);
    }
  });

  onBeforeUnmount(() => {
    if (socket && callbacks.onChatMessage) {
      socket.off("contact-chat:message", callbacks.onChatMessage);
    }
    if (socket && callbacks.onReaction) {
      socket.off("contact-chat:reaction", callbacks.onReaction);
    }
  });
}
